module.exports = __webpack_public_path__ + "img/account.e6b78a35.svg";